export enum WAIVER_BATCH_STATUS {
  OPEN = 'OPEN',
  REFERBACK = 'REFERBACK',
  APPROVED = 'APPROVED',
  VOID = 'VOID',
  PENDING = 'PENDING',
}
